import { isEmptyWhereClause } from '@modules/common/utils';
import { getCombinedWhereClause } from '@modules/dashboard/helpers';
import {
  FeedAndDashboardFilters,
  FeedDashboardFilters,
} from '@modules/feed/store/types';
import { SearchQuery } from '@modules/feed/types';
import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';

interface GetCombinedFeedAndDashboardFiltersOptions {
  primaryQuery: Partial<SearchQuery>;
  dashboardFilters: FeedDashboardFilters | null;
}

export const getCombinedFeedAndDashboardFilters = ({
  primaryQuery,
  dashboardFilters,
}: GetCombinedFeedAndDashboardFiltersOptions): FeedAndDashboardFilters => {
  const primaryWhereClause = primaryQuery.whereClause;
  const dashboardWhereClause = dashboardFilters?.whereClause;

  if (!dashboardWhereClause || isEmptyWhereClause(dashboardWhereClause)) {
    return {
      whereClause: primaryWhereClause ?? EmptyWhereClause,
    };
  }

  return {
    whereClause: getCombinedWhereClause(
      primaryWhereClause ?? EmptyWhereClause,
      dashboardWhereClause,
    ),
  };
};
